export const name = 'EulaController';
export const EULA_VERSION_HEADER = 'EULA-Version';
export const EULA_CURRENT_VERSION_HEADER = 'EULA-Current-Version';
export const EULA_FUTURE_VERSION_HEADER = 'EULA-Future-Version';
export const PRIVACY_VERSION_HEADER = 'PRIVACY-Version';
export default function EulaController($mdDialog, rnHttp, rnLocale, requireAccept, isChanged) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let eulaVersion;

  let vm = this;

  vm.close = close;
  vm.accept = accept;
  vm.eulaText = null;
  vm.requireAccept = requireAccept;
  vm.isChanged = isChanged;
  vm.loading = true;

  vm.activate = activate();
  activate();

  ///////////////////////

  function activate() {
    rnLocale.getBestFit()
      .then(function(locale) {
        getEULA(locale)
        .then(function (response) {
          vm.eulaText = response.data;
          eulaVersion = response.headers(EULA_VERSION_HEADER);
        })
        .catch(function (response) {
          vm.eulaText = response;
        })
        .finally(() => {
          vm.loading = false;
        });
      });
  }

  function close() {
    $mdDialog.cancel();
  }

  function accept() {
    $mdDialog.hide({
      eulaVersion: eulaVersion
    });
  }

  function getEULA(locale) {
    let config = {
      headers: {
        accept: 'text/html'
      }
    };
    return rnHttp.get('portal_service', `/i18n/eula/${locale.shortName}`, config);
  }
}

